"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CustomerService.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CustomerService = function CustomerService(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.85 230.53"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Customer Service Icon"), _react2.default.createElement("path", {
    d: "M149.66,168.1l-34.87-17.42a9.63,9.63,0,0,1-5.33-8.64V129.71q1.26-1.55,2.62-3.48a83.34,83.34,0,0,0,10.78-21.17,14.47,14.47,0,0,0,8.5-13.18V77.27a14.52,14.52,0,0,0-3.65-9.56V48.29c0.2-2,1-14-7.63-23.8-7.5-8.55-19.67-12.88-36.17-12.88S55.27,15.93,47.77,24.48c-8.64,9.85-7.84,21.81-7.63,23.8V67.71a14.52,14.52,0,0,0-3.65,9.56V91.89A14.46,14.46,0,0,0,42,103.22a76.38,76.38,0,0,0,12.78,26.4V141.7a9.64,9.64,0,0,1-5,8.47L17.16,167.92A32.89,32.89,0,0,0,0,196.82v11.81c0,17.32,54.89,21.9,83.92,21.9s83.94-4.58,83.94-21.9v-11.1a32.76,32.76,0,0,0-18.19-29.44h0Zm10.89,40.53c0,5-27,14.59-76.63,14.59S7.31,213.59,7.31,208.64V196.82a25.61,25.61,0,0,1,13.34-22.48L53.2,156.58A17,17,0,0,0,62,141.7V127l-0.86-1a68.84,68.84,0,0,1-12.43-25.78L48.41,98.8,47.16,98a7.25,7.25,0,0,1-3.37-6.11V77.27a7.17,7.17,0,0,1,2.44-5.38l1.19-1.09V47.61a25.24,25.24,0,0,1,5.84-18.32c6.06-6.9,16.37-10.39,30.66-10.39s24.55,3.45,30.61,10.31c7.11,8,5.93,18.3,5.92,18.39l0,23.19,1.21,1.11a7.17,7.17,0,0,1,2.44,5.36V91.89a7.27,7.27,0,0,1-5.19,6.93l-1.82.55-0.59,1.8A76.52,76.52,0,0,1,106.14,122a46.22,46.22,0,0,1-3.07,3.94l-0.91,1V142a16.87,16.87,0,0,0,9.37,15.16l34.85,17.42a25.46,25.46,0,0,1,14.16,22.91v11.1Zm0,0",
    fill: "#e9511e",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M143,68.69l-1.18,0C141,37.72,135,.52,85.07,0,64.39-.21,49.87,4.29,40.33,13.74,26.26,27.66,26,50.28,26,68.7H25.29a9.7,9.7,0,0,0-9.69,9.69V89.21a9.7,9.7,0,0,0,9.69,9.69h3l2.32,0V68.72h0c0-17.58.2-39.14,12.94-51.74C52.17,8.43,65.85,4.42,85,4.57,131.1,5,137,38.87,137.68,69V92.24a17.45,17.45,0,0,1-6.13,13.24c-9.41,8.27-27.13,9.22-36.7,9.07-1.37-2.1-4.83-3.6-8.91-3.6-5.28,0-9.56,2.5-9.56,5.58s4.28,5.58,9.56,5.58c3.66,0,6.81-1.21,8.41-3l2.36,0c10.53,0,27.87-1.47,37.85-10.24a21.83,21.83,0,0,0,6.5-10H143a9.7,9.7,0,0,0,9.69-9.69V78.38A9.71,9.71,0,0,0,143,68.69ZM26.05,94.34H25.29a5.14,5.14,0,0,1-5.12-5.13V78.38a5.13,5.13,0,0,1,5.08-5.13h0.81V94.34Zm122.08-5.13A5.14,5.14,0,0,1,143,94.34h-0.77V92.4s0,0,0-.06h0V73.26H143a5.14,5.14,0,0,1,5.13,5.13V89.21Z",
    fill: "#e9511e",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: undefined
  }));
};
exports.default = CustomerService;